import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import DropdownList from '../../../../components/GeneralForm/DropdownList';
import Page from '../../../../components/Page';
import ScrollToTopBtn from '../../../../components/GeneralForm/ScrollToTop';
import bn from '../../../../utils/bemnames';
import api from '../../../../api';
import ArticleBrief from './ArticleBrief';
import MostRead from './MostRead';
import { getAllInsightiaNewsDataV2 } from '../../../../../src/config/server-config';
import { useGetMostReadNewsQuery } from '../news-api';
import ArticleFull from './ArticleFull';
import qs from 'qs';
import msgConst from '../../../../../src/constants/MessageConstans';
const bem = bn.create('newsNew');
const LIMIT = 10;

const defaultCategories = [
  { label: 'All', value: 0 },
  { label: 'Hit', value: 1 },
  { label: 'Update', value: 2 },
  { label: 'Insightia Archive', value: 3 },
];

export default function InsightiaArchive(props) {
  const location = useLocation();
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });

  const options = props.setSelectNewsDDL || defaultCategories;
  const [selectedCategory, setSelectedCategory] = useState(props.setNewsDDL || defaultCategories[0]);
  const [news, setNews] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);
  const newsBlockRef = useRef(null);
  const mostReadNews = useGetMostReadNewsQuery();

  const fetchNews = (reset = false, selected = selectedCategory) => {
    api
      .post(`${getAllInsightiaNewsDataV2}?limit=${LIMIT}&offset=${reset ? 0 : offset}`, {
        ProductId: 4,
        isVulnerabilityReport: true,
        isVulnerabilityArchive: true,
        tag: selected ? selected.value : 0,
      })
      .then(({ data }) => {
        if (reset) {
          setNews(data);
        } else {
          setNews((prev) => [...prev, ...data]);
        }
        setHasMore(data.length === LIMIT);
        setError(false);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => setIsLoading(false));
  };

  const handleChange = (selection) => {
    setSelectedCategory(selection || defaultCategories[0]);
    setOffset(0);
    setHasMore(true);
    setNews([]);
    setIsLoading(true);
    fetchNews(true, selection);
  };

  useEffect(() => {
    fetchNews(true);
  }, []);

  useEffect(() => {
    if (query.newsID) return;

    const options = { root: null, rootMargin: '200px', threshold: 0.1 };
    const observer = new IntersectionObserver(handleObserver, options);
    const lastItem = document.querySelector('.newsblock > :last-child');

    if (lastItem) observer.observe(lastItem);

    return () => {
      if (lastItem) observer.unobserve(lastItem);
    };
  }, [news, query.newsID]);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting && hasMore && !isLoading) {
      setOffset((prev) => prev + LIMIT);
    }
  };

  useEffect(() => {
    if (offset === 0) return;
    fetchNews();
  }, [offset]);

  const getNewsIds = () => [...new Set(news.map((item) => item.newsid || item.newsId || item.news_id))];

  const handleGetNextPage = () => {
    setIsLoading(true);
    setOffset((prev) => prev + LIMIT);
  };

  return (
    <Page>
      <div className={bem.b('row')}>
        {query.newsID ? (
          <div className="col-xs-12 col-sm-12 col-lg-12 col-xl-12">
            <ArticleFull
              newsId={query.newsID}
              newsIds={getNewsIds()}
              hasMore={hasMore}
              isLoading={isLoading}
              getNextPage={handleGetNextPage}
              backLink={location.pathname}
            />
          </div>
        ) : (
          <>
            <div className="col-xs-12 col-sm-12 col-lg-9 col-xl-9 p-0 position-relative">
              <div className="w-25 pb-4">
                <DropdownList
                  options={options}
                  Dvalue={selectedCategory}
                  handleChange={handleChange}
                  isClearable={false}
                  isMulti={false}
                  maxHeight={80}
                  maxWidth={40}
                  disabled={props.articleMode}
                />
                {isLoading && news.length === 0 && <span>{msgConst.LOADING}</span>}
              </div>
              <div className="newsblock" ref={newsBlockRef}>
                {news.map((newsItem, index) => (
                  <ArticleBrief
                    key={`${index} ${newsItem.newsid || newsItem.newsId || newsItem.news_id}`}
                    newsDetails={newsItem}
                  />
                ))}
                {error && <div>No Search Results Found</div>}
                {hasMore && news.length > 0 && <div className="loading-more m-2">Loading... </div>}
                {!hasMore && news.length === 0 && <div className="my-3">No more articles</div>}
              </div>
            </div>
            <div className="col-xs-12 col-sm-12 col-lg-3 col-xl-3">
              {mostReadNews.data && mostReadNews.data.length > 0 && (
                <div className="mostComponentOverall">
                  <div className="mostReadTitle">Most read</div>
                  <div className="mostVisitNewsContainer">
                    {mostReadNews.data.map((newsItem) => (
                      <MostRead key={newsItem.news_id || newsItem.newsid || newsItem.newsId} newsDetails={newsItem} />
                    ))}
                  </div>
                </div>
              )}
            </div>
            <ScrollToTopBtn />
          </>
        )}
      </div>
    </Page>
  );
}
